<template>
  <div v-if="viewAllowed">
    <tabs persist-as="domainManager">
      <tab name="Domains" :active="true">
        <domains-table-wrapper></domains-table-wrapper>
      </tab>
      <!--       <tab name="IPs">
        Content
      </tab>-->
      <tab name="Providers">
        <providers></providers>
      </tab>
      <tab name="DNS">
        <dns></dns>
      </tab>
      <tab name="Tags">
        <tags></tags>
      </tab>
    </tabs>
  </div>
</template>

<script>
import DomainsTableWrapper from '@/components/legacy/Domainmanager/DomainsTableWrapper'
import Providers from '@/components/legacy/Domainmanager/Providers'
import Tags from '@/components/legacy/Domainmanager/Tags'
import Dns from '@/views/Admin/DomainManager/DnsTable'
import ME_QUERY from '@/graphql/User/MeQuery.gql'

export default {
  components: {
    DomainsTableWrapper,
    Providers,
    Tags,
    Dns
  },
  apollo: {
    me: {
      query: ME_QUERY,
      result({ data }) {
        if (data && data.me) {
          this.me = data.me
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    viewAllowed() {
      if (
        this.me &&
        this.me.roles &&
        this.me.roles.some(role => role.name !== 'sales-admin-level-1')
      ) {
        return true
      }
      return false
    }
  },
  methods: {},
  mounted() {},
  updated() {}
}
</script>
<style></style>
